export * from './pagamentos-e-debitos.service';
